import React from "react";
import LegalDoc from "../../components/LegalDoc";

const TermsOfService: React.FC = () => {
  return (
    <LegalDoc fileName="terms-of-service.txt" documentType="Terms of Service" />
  );
};

export default TermsOfService;
